import { useQuery } from '@apollo/client';
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonList, IonPage, IonRefresher, IonRefresherContent, IonText, IonTitle, IonToolbar } from '@ionic/react';
import { Skeleton } from 'components/Skeleton/Skeleton';
import { AuthContext } from 'contexts/AuthContext';
import { GET_WITHDRAWALS } from 'graphql/queries';
import { chevronBackOutline } from 'ionicons/icons';
import { useContext } from 'react';
import { useHistory } from 'react-router';
import WithdrawalItem from './WithdrawalItem';

const WithdrawalsPage: React.FC = () => {
  const history = useHistory();
  const { authState } = useContext(AuthContext);
  const { data, refetch, loading } = useQuery<{
    withdrawals: any;
  }>(GET_WITHDRAWALS, {
    variables: { user_id: authState.user.uid }
  });

  const doRefresh = async (event:any) => {
    await refetch();
    event.detail.complete();
  }

  return (
    <IonPage>
      <IonHeader className={"ion-no-border"}>
        <IonToolbar className={"background-color"}>
          <IonButtons slot="start">
            <IonButton onClick={() => history.goBack()}>
              <IonIcon icon={chevronBackOutline} color="dark" size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>Withdrawals</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonRefresher slot="fixed" onIonRefresh={doRefresh} >
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>
        <IonList className={'withdrawals-list-root withdrawal-list'}>
          {data?.withdrawals.length === 0 && (
            <IonText>
              <p>No withdrawals</p>
            </IonText>
          )}
          {!data || (loading && <Skeleton />)}
          {data?.withdrawals.map((withdrawal:any, idx:number) => (
            <WithdrawalItem
              key={withdrawal.id}
              noLine={idx === data?.withdrawals?.length - 1}
              withdrawal={withdrawal}
            />
          ))}
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default WithdrawalsPage;
